<template>
  <div class="ee-dropdown" @mouseover="showOptions = true" @mouseleave="showOptions = false">
    <div class="ee-dropdown__toggle">{{current.text}}<i class="text-icon icon-down"></i></div>
    <ul v-show="showOptions" class="ee-dropdown__list">
      <li v-for="item in dataList" @click="handleChange(item)">{{item.text}}</li>
    </ul>
  </div>
</template>
<script>
  export default {
    compName: 'ee-dropdown',
    props: {
      allowEmpty: Boolean,
      value: {
        type: [String, Number],
        default: ''
      },
      list: {
        type: Array,
        required: true
      },
      nullText: {
        type: String,
        default: '请选择'
      }
    },
    methods: {
      handleChange (item) {
        this.$emit('input', item.value)
        this.$emit('change', item)
        this.showOptions = false
      }
    },
    data () {
      return {
        showOptions: false
      }
    },
    computed: {
      current () {
        let cur = {}
        this.dataList.every(item => {
          if (item.value === this.value) {
            cur = item
          }
          return item.value !== this.value
        })
        return cur
      },
      dataList () {
        const re = this.list.map(item => {
          if (typeof item === 'object') {
            return item
          } else if (typeof item === 'string' || (typeof item === 'number' && !isNaN(item))) {
            return {
              text: item,
              value: item
            }
          } else {
            console.warning(`no parse data: ${item}`)
            return {}
          }
        })
        if (this.allowEmpty) {
          re.unshift({
            value: '',
            text: this.nullText
          })
        }
        return re
      }
    }
  }
</script>
<style src="../style/dropdown.css"></style>



// WEBPACK FOOTER //
// src/packages/dropdown/Dropdown.vue?1fc6dc9f